import { ApiService } from "@/api";

export default {
  GET_SERVERS_LIST({ commit }, { query, page, count }) {
    return ApiService.servers
      .getList({
        search: encodeURI(query) || "",
        page,
        count,
      })
      .then((servers) => {
        commit("SET_LIST_SERVERS", servers);
        return servers;
      });
  },
};
